<template>
    
    <div class="papsi-wrapper">
        <h1 class="text-2xl font-semibold text-[#24723b]">Employee Job Description
        </h1>
        <p class="text-xs text-[#747474] mt-2">Home / Employee Page /  Personnel Services / Job Description</p>
    </div>
    <div class="papsi-wrapper flex mt-7 flex-col">
        <div class="flex items-center gap-5">
            <!-- <h1 class="text-[#24723b] font-semibold text-lg" >Employee Job Description Search / Edit </h1> -->
            <!-- <button class="bg-[#24723b] w-[200px] py-3 text-sm p-2 rounded-lg text-white hover:bg-[#24723bb6]" v-on:click="AddJobdescription =! AddJobdescription">{{ ViewTable }}</button> -->
        </div>
        <div class="mt-11" v-if="TableView">
            <div class="grid grid-cols-11 w-full gap-3 mb-5">
                <input type="text"  @input="isTyping = true" placeholder="Search" class="col-span-3 border-[#b7b8b7] border p-2 px-5 rounded-md  outline-none  text-[#535353] text-sm" v-model="search">
                <select class="width[] border-[#b7b8b7] border  rounded-md   outline-none  text-[#535353] text-center text-sm" v-model="sort" @change="jdFilter" >
                    <option value="R">RANK AND FILE</option>
                    <option value="S">SUPERVISOR</option>
                    <option value="M">MANAGER</option>
                    <option value="E">EXECUTIVE</option>
                    <option value="ALL">ALL</option>                      
                </select>
            </div>
            <div class="bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
                <TableControl :Action="true" @EditButton="EditButton" @ViewButton="ViewButton" @DeleteButton="receiveEmit" :column="column" :header="header" :info="info" :DButton="false" :EButton="true" :VButton="true"/>
            </div>
        </div>
    </div>

    <div v-if="AddJobdescription">
        <div @click="AddJobdescription = false" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
        </div>
            <div class="flex flex-col justify-center absolute left-0 top-[30%] mx-[40%] z-40 bg-white w-[450px] text-lg rounded-lg border-[2px] border-[#0B6014]">
                <div class="pafcpic_header bg-green-800 py-3 px-6">
                    <p class="text-[#ffffff] text-md font-semibold">Add Employee Job Description</p>
                </div>
                <div class="pafcpic_body py-6 px-6">
                    <input type="text" v-model="remarks" class="text-sm mt-1 py-2 px-3 w-full border-[#24723b6c] border-[1px] rounded-sm" placeholder="Remarks">
                    <p class="text-sm text-[#414141] mt-3 font-medium ">Upload PDF Job Description</p>
                    <input type="file" @change="onFileChange" class="text-sm mt-1 py-2 px-3 w-full border-[#24723b6c] border-[1px] rounded-sm">
                </div>
            <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#0080002a] border-t font-medium">
                <button class="text-sm text-white bg-green-800 py-1.5 px-7 rounded-md" v-on:click="updateJobDescription()">Add</button>
                <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md" v-on:click="AddJobdescription = false">Cancel</button>
            </div>
            </div>
    </div>

    <Modal @outside="outsidemodal" @confirmation="test" v-show="modal"/>
    <Loading v-show="loading"/>

    <div v-if="nojd">
        <Prompt @CloseSignatory="nojd = false" type="NOJD"/>
    </div>

</template>

<script>
import _ from 'lodash';
import { defineComponent } from 'vue';
import TableControl from '../../controls/TableControl/TableControl.vue'
import Modal from '../../controls/modal/ModalSample.vue'
import Services from '../../../services/admin'
import Loading from '../../controls/Loading/LoadingControl.vue'

import Prompt from '../Prompt/RequestPromt.vue'

export default defineComponent({
    components:{
        TableControl,
        Modal,
        Loading,
        Prompt
    },
    data(){
            return{
                sort:'ALL',
                search:'',
                isTyping:false,
                nojd: false,
                modal: false,
                AddJobdescription: false,
                TableView:true,
                ViewTable: 'Assign Job Description',
                info: '',
                position:'',
                file: '',
                Addjob:'',
                EditID: '',
                remarks:'',
                sample:'',
                source:'',
                loading:false,
                header:[
                {
                    id: 1,
                    label: 'NoofItems',
                    title: 'No',
                    visible: true
                },
                {
                    id: 2,
                    label: 'Position',
                    title: 'Position',
                    visible: true
                },
                {
                    id: 3,
                    label: 'Category',
                    title: 'Category',
                    visible: true
                },
                {
                    id: 4,
                    label: 'Job Description',
                    title: 'Job Description',
                    visible: true
                },
                {
                    id: 5,
                    label: 'Action',
                    title: 'Action',
                    visible: true
                }
                ],
                column:[
                    'index',
                    'job_name',
                    'rank',
                    'nojd'
                ], 
            }
        },
        watch: {
                search: _.debounce(function() {
                this.isTyping = false;
                }, 600),
                isTyping: function(value) {
                if (!value) {
                    this.searchPosition()
                }
                }
        },
        mounted(){
            this.getAllPosition()
        },
        methods: {
            test(){
                this.modal = false  
            },
            jdFilter(){
                if(this.sort == 'ALL' ){
                    this.info = this.searchInfo
                    return
                }
                this.info = this.searchInfo.filter(jd=>jd.rank == this.sort)
            },
            async getAllPosition(){
                this.$emit("showLoader")
                const success    =  await Services.getJobDescription(this.search)
                this.searchInfo        =  success.data
                this.info        =  success.data
                this.$emit("hideLoader")
            },
            async searchPosition(){
         
                const success     =  await Services.getJobDescription(this.search)
                this.searchInfo   =  success.data
                this.info         =  success.data
                this.jdFilter()
          
            },
            onFileChange(e){
            this.file = e.target.files[0];
            },
            outsidemodal(){
                this.modal = false  
            },
            HideView(){
                if (!this.TableView){
                    this.TableView = true
                    this.AddJobdescription = false
                    this.ViewTable = '+ Assign Job Description'
                }
                else{
                    this.TableView = false
                    this.AddJobdescription = true
                    this.ViewTable = 'View Table'
                }
            },
            async ViewButton(row){
                this.loading = true
                try {
                    const success = await Services.getJobDescriptionbyID(row.position_key);
                    this.source = success.data.source
                    this.viewFile();
                } catch (error) {
                    console.error("Error:", error);
                }
            },
            viewFile(){
                if (!this.source) {
                        this.nojd = true
                        this.loading = false
                        return;
                    }
                   
                    let pdfWindow = window.open("");
                    setTimeout(() => {
                        pdfWindow.stop();
                        pdfWindow.document.write(
                        "<html style='margin:0 0 0 0; padding:0 0 0 0;'><title>JOB DESCRIPTION</title></title></title></html><iframe style='margin:0 0 0 0; padding:0 0 0 0; width: 100%; height: 100%; border: none; position:fixed; top:0; right:0;' src='data:application/pdf;base64, " +
                        encodeURI(this.source) + "'></iframe></html>"
                        );
                    }, 1000);
                    this.loading = false
            },
            EditButton(data){
                this.AddJobdescription = true
                this.EditID = data.position_key
                
            },
            async updateJobDescription(){
                this.$emit("showLoader")
                const success    =  await Services.updateJobDescription(this.EditID,this.remarks,this.file)
                this.sample      =  success.data 
                this.getAllPosition()
                this.AddJobdescription  = false
                this.$emit("hideLoader")
            }
        },
        
})
</script>



